
export const LOAD_CARD = "LOAD_CARD";
export const LOAD_CARD_SUCCESS = "LOAD_CARD_SUCCESS";
export const SEARCH_RES = "SEARCH_RES";
export const SEARCH_RES_SUCCESS = "SEARCH_RES_SUCCESS";
export const GET_TABLE_DATA = "GET_TABLE_DATA";
export const GET_TABLE_DATA_SUCCESS = "GET_TABLE_DATA_SUCCESS";
export const GET_GLOBALDATA = "GET_GLOBALDATA"
export const GET_GLOBALDATA_SUCCESS = "GET_GLOBALDATA_SUCCESS"


